import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { captureMessage } from '@sentry/react';

import { localStorage } from './index';

export const regexpRef = /^((ref|hr)\s*:?\s*)?(\d){4}$/;

export const renderComponent = <P extends object>(
  Element: React.ComponentType<P>,
  props?: P,
  selector = ''
): void => {
  let container: HTMLElement;

  if (selector) {
    container = document.querySelector(selector) as HTMLElement;

    if (!container) {
      captureMessage(`renderComponent: element not found for selector "${selector}"`, {
        level: 'warning',
        extra: { component: Element.displayName ?? Element.name }
      });
      return;
    }
  } else {
    container = document.createElement('div');
    document.body.appendChild(container);
  }

  const root = createRoot(container);
  // eslint-disable-next-line react/jsx-props-no-spreading
  root.render(<StrictMode><Element {...(props ?? ({} as P))} /></StrictMode>);
};

export const reloadMobileHandler = (): void => {
  let mobile = localStorage.getItem('mobile') === String(true);
  localStorage.setItem('mobile', mobile.toString());

  window.addEventListener('resize', () => {
    const width = window.innerWidth;
    const desktopWidth = 1024;

    if (width <= desktopWidth && !mobile) {
      mobile = true;
      localStorage.setItem('mobile', String(mobile));
      window.location.reload();
    } else if (width > desktopWidth && mobile) {
      mobile = false;
      localStorage.setItem('mobile', String(mobile));
      window.location.reload();
    }
  });
};

export const appendToList = (selector: string, items: string[]): void => {
  const housesList = document.querySelector(selector);

  if (!housesList) {
    return;
  }

  const firstItem = housesList.querySelector('li');

  if (!firstItem) {
    return;
  }

  const { className } = firstItem;

  (items || []).forEach((html) => {
    const liElement = document.createElement('li');
    liElement.className = className;
    liElement.innerHTML = html;
    housesList.appendChild(liElement);
  });
};
